import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/rate-finder', component: () => import('./RateFinder.vue') },
  { path: '/:catchAll(.*)', component: () => import('./Shop.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
